module.exports = __webpack_public_path__ + "static/media/lucia.8f6279af.png";